// src/modules/communications/services/softphoneService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getAuthToken = () => localStorage.getItem('token');

const getHeaders = () => ({
  headers: {
    Authorization: `Bearer ${getAuthToken()}`
  }
});

export const getSoftphoneToken = async () => {
  const response = await axios.get(
    `${API_URL}/communications/softphone-token`,
    getHeaders()
  );
  return response.data;
};

export const searchLeads = async (query) => {
  const response = await axios.get(
    `${API_URL}/leads/search?query=${encodeURIComponent(query)}`,
    getHeaders()
  );
  return response.data;
};
